module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<label #label [for]=\"config.forAttribute\">{{ (config.textKey | translate) || 'Custom Label Component'}}</label>"


//////////////////
// WEBPACK FOOTER
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/label/label.component.html
// module id = ../../../../../src/app/shared/components/label/label.component.html
// module chunks = main